export default "__VITE_ASSET__b1f70b48__"